import { Container, Accordion, Card, Badge, Button } from "react-bootstrap";
import { FaLock, FaShieldAlt, FaBalanceScale, FaFileContract, FaQuestionCircle } from "react-icons/fa";
import { useTranslation, Trans } from "react-i18next";

function TermsOfService() {
  const { t } = useTranslation();

  return (
    <Container className="py-5" style={{ maxWidth: "800px" }}>
      {/* Hero Section */}
      <div className="text-center mb-5">
        <h1 className="display-4 mb-3">
          <span className="text-primary">🐨</span> {t("TermsOfService.title")}
        </h1>
        <p className="lead">{t("TermsOfService.subtitle")}</p>
        <Badge bg="light" text="dark" className="mt-2">
          {t("TermsOfService.lastUpdated", {
            date: new Date().toLocaleDateString(),
          })}
        </Badge>
      </div>

      {/* Main Content */}
      <Card className="shadow-sm border-0 rounded-3">
        <Card.Body className="p-4">
          <Accordion defaultActiveKey="0" flush alwaysOpen>
            {/* Acceptance */}
            <Accordion.Item eventKey="0" className="border-0">
              <Accordion.Header>
                <FaFileContract className="text-primary me-3" />
                <h5 className="mb-0">{t("TermsOfService.accordion.acceptanceTitle")}</h5>
              </Accordion.Header>
              <Accordion.Body>
                <Trans i18nKey="TermsOfService.accordion.acceptanceBody">
                  By using KokoFin ("Service"), you agree to these Terms and our
                  <a href="/privacy" className="text-decoration-none">
                    Privacy Policy
                  </a>
                  .
                </Trans>
              </Accordion.Body>
            </Accordion.Item>

            {/* User Responsibilities */}
            <Accordion.Item eventKey="1" className="border-0">
              <Accordion.Header>
                <FaBalanceScale className="text-primary me-3" />
                <h5 className="mb-0">{t("TermsOfService.accordion.responsibilitiesTitle")}</h5>
              </Accordion.Header>
              <Accordion.Body>
                <ul className="list-unstyled">
                  <li>{t("TermsOfService.accordion.responsibilitiesList.accurateReceipts")}</li>
                  <li>{t("TermsOfService.accordion.responsibilitiesList.noFraud")}</li>
                  <li>{t("TermsOfService.accordion.responsibilitiesList.accountSecurity")}</li>
                  <li>{t("TermsOfService.accordion.responsibilitiesList.contactUpdate")}</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            {/* AI Processing */}
            <Accordion.Item eventKey="2" className="border-0">
              <Accordion.Header>
                <FaShieldAlt className="text-primary me-3" />
                <h5 className="mb-0">{t("TermsOfService.accordion.aiTitle")}</h5>
              </Accordion.Header>
              <Accordion.Body>
                <p>{t("TermsOfService.accordion.aiBodyIntro")}</p>
                <ul>
                  <li>{t("TermsOfService.accordion.aiBodyList.patterns")}</li>
                  <li>{t("TermsOfService.accordion.aiBodyList.categories")}</li>
                  <li>{t("TermsOfService.accordion.aiBodyList.merchant")}</li>
                </ul>
                <p className="text-muted">
                  <small>{t("TermsOfService.accordion.aiBodyNote")}</small>
                </p>
              </Accordion.Body>
            </Accordion.Item>

            {/* Termination */}
            <Accordion.Item eventKey="3" className="border-0">
              <Accordion.Header>
                <FaLock className="text-primary me-3" />
                <h5 className="mb-0">{t("TermsOfService.accordion.accountTitle")}</h5>
              </Accordion.Header>
              <Accordion.Body>
                <p>{t("TermsOfService.accordion.accountBody")}</p>
                <div className="alert alert-warning mt-3">
                  <strong>{t("TermsOfService.accordion.accountWarning.label")}</strong>{" "}
                  {t("TermsOfService.accordion.accountWarning.content")}
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* Limitation of Liability */}
            <Accordion.Item eventKey="4" className="border-0">
              <Accordion.Header>
                <FaQuestionCircle className="text-primary me-3" />
                <h5 className="mb-0">{t("TermsOfService.accordion.disclaimerTitle")}</h5>
              </Accordion.Header>
              <Accordion.Body>
                <p>{t("TermsOfService.accordion.disclaimerBodyIntro")}</p>
                <ul>
                  <li>{t("TermsOfService.accordion.disclaimerList.financial")}</li>
                  <li>{t("TermsOfService.accordion.disclaimerList.unreadable")}</li>
                  <li>{t("TermsOfService.accordion.disclaimerList.thirdParty")}</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Card.Body>
      </Card>

      {/* Contact Section */}
      <div className="text-center mt-5 p-4 bg-light rounded-3">
        <h5 className="mb-3">{t("TermsOfService.contact.title")}</h5>
        <Button variant="primary" href="/contact">
          {t("TermsOfService.contact.button")}
        </Button>
        <p className="mt-3 text-muted small">
          {t("TermsOfService.contact.email")}
          <br />
          {t("TermsOfService.contact.responseTime")}
        </p>
      </div>
    </Container>
  );
}

export default TermsOfService;
